export const BASE_64_IMG = "data:image/png;base64,";
export const DEFAULT_LOGO = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
